export const ZONA_HORARIA_DEFAULT = 'America/Santiago';

export const ZONAS_HORARIA_OPCIONES: { value: string; label: string }[] = [
  { value: 'America/Santiago', label: 'Chile (America/Santiago)' },
  { value: 'America/Mexico_City', label: 'México — Centro (America/Mexico_City)' },
  { value: 'America/Tijuana', label: 'México — Pacífico (America/Tijuana)' },
  { value: 'America/Cancun', label: 'México — Sureste (America/Cancun)' },
  { value: 'America/Bogota', label: 'Colombia (America/Bogota)' },
  { value: 'America/Lima', label: 'Perú (America/Lima)' },
  { value: 'America/Argentina/Buenos_Aires', label: 'Argentina (America/Argentina/Buenos_Aires)' },
];
